export const MAPBOX_TOKEN_1 =
  process.env.REACT_APP_MAPBOX_TOKEN || 'mapbox-token';

export const GOOGLE_MAP_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_TOKEN || 'google-token';

export const GOOGLE_GLOBAL_KEY = 'google';
